import { api } from './client';

export const gasApi = {
  /**
   * Ask the backend to drip a little POL to `address` if it qualifies
   * (holds >= $100 USDT and has ~no POL). Safe to call optimistically — the
   * backend decides whether to actually send, and returns `skipped` if not.
   */
  topup: (address: string) =>
    api<{ txHash?: string; skipped?: string; error?: string }>('/api/gas/topup', {
      method: 'POST',
      body: { address },
    }),
};
